module.exports = __webpack_public_path__ + "img/default-bg-zh.51f328fd.png";